import { useUserStore } from "../../api/users/store"
import BankAccountView from "../../components/BankAccountView"
import CAccordion from "../../components/CAccordion"
import CStack from "../../components/CStack"

const CasaView = ({}) => {
    const { currentUserCasa, retrieveCasa} = useUserStore( state => state)

    return (
        <CAccordion label="Casa" onExpand={() => retrieveCasa()}>
            {currentUserCasa === null && <>Empty</>}
            {currentUserCasa !== null && currentUserCasa.map( item => (
                <BankAccountView accNum={item.AccountNumber} 
                    status={item.AccountStatus}
                    balance={item.OutstandingBalance}/>
            ))}
        </CAccordion>
    )
}

const LoanView = ({}) => {
    const { currentUserLoan, retrieveLoan} = useUserStore( state => state)

    return (
        <CAccordion label="Loans" onExpand={() => retrieveLoan()}>
            {currentUserLoan === null && <>Empty</>}
            {currentUserLoan !== null && currentUserLoan.length === 0 && <>Empty</>}
            {currentUserLoan !== null && currentUserLoan.map( item => (
                <BankAccountView accNum={item.AccountNumber} 
                    status={item.PaymentStatus}
                    balance={item.OutstandingBalance}/>
            ))}
        </CAccordion>
    )
}

const TDView = () => {
    const { currentUserTD, retrieveTD} = useUserStore( state => state)

    return (
        <CAccordion label="Time Deposit" onExpand={() => retrieveTD()}>
            {currentUserTD === null && <>Empty</>}
            {currentUserTD !== null && currentUserTD.map( item => (
                <BankAccountView accNum={item.AccountNumber} 
                    status={item.AccountStatus}
                    balance={item.OutstandingBalance}/>
            ))}
        </CAccordion>
    )
}

const SCAView = ({}) => {
    const { currentUserSCA, retrieveSCA} = useUserStore( state => state)

    return (
        <CAccordion label="Shared Capital" onExpand={() => retrieveSCA()}>
            {currentUserSCA === null && <>Empty</>}
            {currentUserSCA !== null && currentUserSCA.map( item => (
                <BankAccountView accNum={item.AccountNumber} 
                    status={item.AccountStatus}
                    balance={item.OutstandingBalance}/>
            ))}
        </CAccordion>
    )
}

const AccountList = () => {
    return <CStack header="Accounts">
        <CasaView />
        <TDView />
        <LoanView />
        <SCAView />
    </CStack>
}
export default AccountList